import Order from './Order';
import ArticleGroup from './ArticleGroup';
import Payment from './Payment';
import Customer from './Customer';
import { OrderType } from '../enums/OrderType';
import Preorder from './Preorder';
import { PreorderType } from '../enums/PreorderType';
import { deepClone, numberD, sanitizeId } from '../utils/utils';
import dayjs from 'dayjs';

export function orderBody(order: Partial<Order>, keepPreorder = false) {
	// @ts-ignore
	order.preorder.deliveryFeeNet = undefined;
	return {
		_id: order._id ? order._id : undefined,
		venue: order.venue,
		status: order.status,
		type: keepPreorder ? OrderType.STANDARD : order.type,
		preorder: order.type === OrderType.PREORDER || keepPreorder ? preorderBody(order.preorder) : undefined,
		orderAt: order.orderAt ? dayjs(order.orderAt).set('seconds', 0).set('milliseconds', 0).toISOString() : undefined,
		asap: order.asap,
		flavor: order.flavor,
		orderedArticles: order?.orderedArticles?.map(value => ArticleGroupConverter.toBody(value)),
		table: order.table ? order.table : undefined,
		tableNumber: order.tableNumber !== 'preorder_table' ? order.tableNumber : undefined,
		userUid: sanitizeId(order?.userUid ?? ''),
		terminalorder: order.type === OrderType.TERMINAL ? order.terminalorder : undefined,
		loyaltyNumber: order.loyaltyNumber ? order.loyaltyNumber : undefined,
		sendToSalesforce: order?.sendToSalesforce ?? false,
		clientMeta: order?.clientMeta ?? undefined,
	};
}

export function preorderBody(preorder: Partial<Preorder> | undefined) {
	if (!preorder) {
		return null;
	}
	return {
		type: preorder.type,
		personCount: 1,
		name: preorder.name,
		email: preorder.email,
		phone: preorder.phone,
		note: preorder.note,
		postalCode: preorder.postalCode,
		companyName: preorder.companyName,
		floor: preorder.floor,
		country: preorder.country,
		city: preorder.city,
		street: preorder.street,
		number: preorder.number,
		subcard: preorder.subcard,
		licenseNumber: preorder.type === PreorderType.PARK_COLLECT ? preorder.licenseNumber : undefined,
		vehicleBrand: preorder.type === PreorderType.PARK_COLLECT ? preorder.vehicleBrand : undefined,
		vehicleColor: preorder.type === PreorderType.PARK_COLLECT ? preorder.vehicleColor : undefined,
		lat: preorder.lat !== undefined ? '' + preorder.lat : undefined,
		lng: preorder.lng !== undefined ? '' + preorder.lng : undefined,
	};
}

export function customerBody(customer: Partial<Customer>, removeId: boolean = false) {
	return {
		_id: removeId ? undefined : customer._id,
		name: customer.name,
		street: customer.street,
		city: customer.city,
		postalCode: customer.postalCode,
		companyName: customer.companyName,
		preferredVenues: customer.preferredVenues,
		floor: customer.floor,
		country: customer.country,
		subcard: customer.subcard,
		loyaltyNumber: customer.loyaltyNumber ? customer.loyaltyNumber : customer.subcard,
		number: customer.number,
		userUid: sanitizeId(customer.uid ?? ''),
		gender: customer.gender,
		phone: customer.phone,
		email: customer.email,
	};
}

export function paymentBody(payment: Partial<Payment>, removeId: boolean = false) {
	return {
		_id: removeId ? undefined : payment._id,
		orders:
			payment?.orders?.map(order => {
				return typeof order === 'string' ? order : order?._id;
			}) ?? [],
		tip: payment.tip ? '' + numberD(payment.tip) : undefined,
		response: payment && payment.response ? deepClone(payment.response) : null,
		session: payment.session,
		status: payment.status,
		method: payment.method,
		sum: payment.sum,
		adyenPayment: payment.adyenPayment ?? null,
		transactionType: payment.transactionType,
		isAdyenPaypal: payment?.isAdyenPaypal ?? false,
		piggyGiftCards: payment.piggyGiftCards ?? undefined,
		preAuth: payment.preAuth ?? false,
	};
}

export class ArticleGroupConverter {
	static toBody(articleGroup: Partial<ArticleGroup>) {
		return {
			article: articleGroup?.article?._id,
			quantity: articleGroup.quantity,
			groups: articleGroup?.groups?.map(value => {
				return {
					group: value.group,
					article: value.article._id,
					quantity: value.quantity,
					dependsOn: value.dependsOn,
					dependency: value.dependency,
					dependencyNumber: value.dependencyNumber,
				};
			}),
			isRecommendedRecipe: articleGroup.isRecommendedRecipe ? articleGroup.isRecommendedRecipe : false,
			freeArticle: articleGroup.freeArticle ? articleGroup.freeArticle : false,
			isPromo: articleGroup.isPromo ? articleGroup.isPromo : false,
			note: articleGroup.note || articleGroup.note === '' ? articleGroup.note : undefined,
		};
	}
}
